// extracted by mini-css-extract-plugin
export default {"widgetCardsWrapper":"ProductivityRiskTrend_widgetCardsWrapper__yzyES","chart":"ProductivityRiskTrend_chart__3Tpcd"};